module.exports = __webpack_public_path__ + "img/sliders-01.15b51ba3.jpg";